<template>
  <div class="order-manage-container">
    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <i class="el-icon-document stats-icon total"></i>
            <div class="stats-info">
              <div class="stats-label">总订单数</div>
              <div class="stats-value">{{ statistics.totalCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <i class="el-icon-time stats-icon pending"></i>
            <div class="stats-info">
              <div class="stats-label">待支付</div>
              <div class="stats-value">{{ statistics.pendingCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <i class="el-icon-success stats-icon paid"></i>
            <div class="stats-info">
              <div class="stats-label">已支付</div>
              <div class="stats-value">{{ statistics.paidCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card">
          <div class="stats-content">
            <i class="el-icon-close stats-icon cancelled"></i>
            <div class="stats-info">
              <div class="stats-label">已取消</div>
              <div class="stats-value">{{ statistics.cancelledCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="searchForm.userName" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-select v-model="searchForm.paymentStatus" placeholder="请选择" clearable>
            <el-option label="待支付" :value="0"></el-option>
            <el-option label="已支付" :value="1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="searchForm.paymentMethod" placeholder="请选择" clearable>
            <el-option label="微信支付" value="wechat"></el-option>
            <el-option label="支付宝" value="alipay"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单列表 -->
    <el-card class="table-card">
      <el-table :data="orderList" v-loading="loading" stripe border>
        <el-table-column prop="orderNo" label="订单号" min-width="180" fixed></el-table-column>
        <el-table-column prop="frontUserName" label="用户名" width="120"></el-table-column>
        <el-table-column prop="membershipLevelName" label="会员等级" width="100"></el-table-column>
        <el-table-column label="时长类型" width="100">
          <template slot-scope="scope">
            {{ getDurationTypeName(scope.row.durationType) }}
          </template>
        </el-table-column>
        <el-table-column prop="actualPrice" label="实付金额" width="100">
          <template slot-scope="scope">
            <span class="price">¥{{ scope.row.actualPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.paymentMethod === 'wechat'" type="success" size="small">微信</el-tag>
            <el-tag v-else-if="scope.row.paymentMethod === 'alipay'" type="primary" size="small">支付宝</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.paymentStatus === 0" type="warning" size="small">待支付</el-tag>
            <el-tag v-else-if="scope.row.paymentStatus === 1" type="success" size="small">已支付</el-tag>
            <el-tag v-else-if="scope.row.paymentStatus === 2" type="info" size="small">已取消</el-tag>
            <el-tag v-else-if="scope.row.paymentStatus === 3" type="danger" size="small">已退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paymentTime" label="支付时间" width="160">
          <template slot-scope="scope">
            {{ formatTime(scope.row.paymentTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="handleEditRemark(scope.row)">备注</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        class="pagination">
      </el-pagination>
    </el-card>

    <!-- 订单详情对话框 -->
    <el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="700px">
      <el-descriptions v-if="currentOrder" :column="2" border>
        <el-descriptions-item label="订单号">{{ currentOrder.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="用户名">{{ currentOrder.frontUserName }}</el-descriptions-item>
        <el-descriptions-item label="会员等级">{{ currentOrder.membershipLevelName }}</el-descriptions-item>
        <el-descriptions-item label="时长类型">{{ getDurationTypeName(currentOrder.durationType) }}</el-descriptions-item>
        <el-descriptions-item label="时长天数">{{ currentOrder.durationDays }} 天</el-descriptions-item>
        <el-descriptions-item label="原价">¥{{ currentOrder.originalPrice }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">
          <span class="price">¥{{ currentOrder.actualPrice }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">
          <el-tag v-if="currentOrder.paymentMethod === 'wechat'" type="success" size="small">微信支付</el-tag>
          <el-tag v-else-if="currentOrder.paymentMethod === 'alipay'" type="primary" size="small">支付宝</el-tag>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付状态">
          <el-tag v-if="currentOrder.paymentStatus === 0" type="warning" size="small">待支付</el-tag>
          <el-tag v-else-if="currentOrder.paymentStatus === 1" type="success" size="small">已支付</el-tag>
          <el-tag v-else-if="currentOrder.paymentStatus === 2" type="info" size="small">已取消</el-tag>
          <el-tag v-else-if="currentOrder.paymentStatus === 3" type="danger" size="small">已退款</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="第三方交易号">{{ currentOrder.transactionId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="支付时间">{{ formatTime(currentOrder.paymentTime) }}</el-descriptions-item>
        <el-descriptions-item label="会员开始时间">{{ formatTime(currentOrder.startTime) }}</el-descriptions-item>
        <el-descriptions-item label="会员到期时间">{{ formatTime(currentOrder.expireTime) }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(currentOrder.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ currentOrder.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 编辑备注对话框 -->
    <el-dialog title="编辑备注" :visible.sync="remarkDialogVisible" width="500px">
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入备注信息"
        v-model="remarkForm.remark"
        maxlength="255"
        show-word-limit>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveRemark">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MembershipOrderManage',
  data() {
    return {
      loading: false,
      orderList: [],
      searchForm: {
        orderNo: '',
        userName: '',
        paymentStatus: null,
        paymentMethod: ''
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      statistics: {
        totalCount: 0,
        pendingCount: 0,
        paidCount: 0,
        cancelledCount: 0
      },
      detailDialogVisible: false,
      remarkDialogVisible: false,
      currentOrder: null,
      remarkForm: {
        remark: ''
      }
    }
  },
  created() {
    this.loadOrderList()
    this.loadStatistics()
  },
  methods: {
    async loadOrderList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        
        const res = await this.$axios.get('/admin/membership-order/list', { params })
        
        if (res.data.code === 200) {
          this.orderList = res.data.data.records
          this.pagination.total = res.data.data.total
        }
      } catch (error) {
        console.error('加载订单列表失败:', error)
        this.$message.error('加载订单列表失败')
      } finally {
        this.loading = false
      }
    },
    
    async loadStatistics() {
      try {
        const res = await this.$axios.get('/admin/membership-order/statistics')
        if (res.data.code === 200) {
          this.statistics = res.data.data
        }
      } catch (error) {
        console.error('加载统计信息失败:', error)
      }
    },
    
    handleSearch() {
      this.pagination.page = 1
      this.loadOrderList()
    },
    
    handleReset() {
      this.searchForm = {
        orderNo: '',
        userName: '',
        paymentStatus: null,
        paymentMethod: ''
      }
      this.handleSearch()
    },
    
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.loadOrderList()
    },
    
    handleCurrentChange(page) {
      this.pagination.page = page
      this.loadOrderList()
    },
    
    async handleViewDetail(row) {
      try {
        const res = await this.$axios.get(`/admin/membership-order/${row.id}`)
        if (res.data.code === 200) {
          this.currentOrder = res.data.data
          this.detailDialogVisible = true
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      }
    },
    
    handleEditRemark(row) {
      this.currentOrder = row
      this.remarkForm.remark = row.remark || ''
      this.remarkDialogVisible = true
    },
    
    async handleSaveRemark() {
      try {
        const res = await this.$axios.put(`/admin/membership-order/${this.currentOrder.id}/remark`, {
          remark: this.remarkForm.remark
        })
        
        if (res.data.code === 200) {
          this.$message.success('备注保存成功')
          this.remarkDialogVisible = false
          this.loadOrderList()
        } else {
          this.$message.error(res.data.message || '保存失败')
        }
      } catch (error) {
        console.error('保存备注失败:', error)
        this.$message.error('保存备注失败')
      }
    },
    
    getDurationTypeName(type) {
      const map = {
        1: '月付',
        2: '季付',
        3: '年付'
      }
      return map[type] || '-'
    },
    
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.order-manage-container {
  padding: 20px;
}

.stats-row {
  margin-bottom: 20px;
}

.stats-card {
  cursor: pointer;
  transition: all 0.3s;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.stats-content {
  display: flex;
  align-items: center;
  padding: 10px;
}

.stats-icon {
  font-size: 48px;
  margin-right: 20px;
}

.stats-icon.total {
  color: #409EFF;
}

.stats-icon.pending {
  color: #E6A23C;
}

.stats-icon.paid {
  color: #67C23A;
}

.stats-icon.cancelled {
  color: #909399;
}

.stats-info {
  flex: 1;
}

.stats-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.stats-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

.search-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.table-card {
  margin-bottom: 20px;
}

.price {
  color: #F56C6C;
  font-weight: bold;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
